import { render, staticRenderFns } from "./confirmationFormSubmittion.vue?vue&type=template&id=4c483dfa&scoped=true"
var script = {}
import style0 from "./confirmationFormSubmittion.vue?vue&type=style&index=0&id=4c483dfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c483dfa",
  null
  
)

export default component.exports